import { HttpClient } from '@angular/common/http';
import { Component, Injector, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-document',
  templateUrl: './document.component.html',
  styleUrl: './document.component.scss'
})
export class DocumentComponent implements OnInit {
  constructor(private injector: Injector, private router: Router) { }
  myDoc :any;

  ngOnInit(): void {
    let http = this.injector.get(HttpClient);
    this.myDoc = '/assets/documents/Documentation/SyncHPC Installation Guide.md';
  }
}
